import { z } from 'zod';

import { AbstractMeasurement } from './AbstractMeasurement';

const units = ['%/°C'] as const;

const validator = AbstractMeasurement.value
    .extend({
        unit: z.literal('%/°C').default('%/°C'),
    })
    .optional();

export const TemperatureCoefficient = {
    validator,
    units,
};
